import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import WorldMapScene, { MAP_W, MAP_H } from '../game/WorldMapScene.js';

/**
 * React wrapper — embed Phaser canvas เป็น "เกาะ" ในหน้า Team (React shell เดิมไม่ทิ้ง)
 * รับ pins + totalKm จาก getTeam แล้วสร้าง scene ครั้งเดียวต่อ mount
 */
export default function WorldMapGame({ pins, totalKm, chosenChar }) {
  const hostRef = useRef(null);

  useEffect(() => {
    const game = new Phaser.Game({
      type: Phaser.AUTO,
      parent: hostRef.current,
      width: MAP_W,
      height: MAP_H,
      transparent: true,
      scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_HORIZONTALLY },
      scene: new WorldMapScene({ pins, totalKm, chosenChar }),
    });
    return () => game.destroy(true);
    // สร้างใหม่เมื่อข้อมูล/ตัวละครเปลี่ยน
  }, [pins, totalKm, chosenChar]);

  return <div ref={hostRef} className="worldmap" />;
}
